import { Order, OrderPatchResponse, OrderPayload } from '~/types/order'
import { homApi } from '~/redux/apis/hom'
import { createBookingForSelfCartItemFromOrderPreference } from '~/booking/utils/createBookingForSelfCartItemFromOrderPreference'
import { OrderPreference } from '~/booking/types'
import { TutorBookingCommonFields } from '~/types/cart'
import { STUDENT_API_TAGS } from '~/redux/constants/tags.const'
import { getMetaCookies } from '~/utils/cookie.utils'

export const orderApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    addOrder: builder.mutation<Order, OrderPayload>({
      query: (body) => ({
        url: '/v2/orders',
        method: 'POST',
        params: getMetaCookies(),
        body,
      }),
      // Invalidates all Order-type queries providing the `LIST` id - after all, depending of the sort order,
      // that newly created order could show up in any lists.
      // invalidatesTags: [{ type: 'Orders', id: 'LIST' }],
    }),

    applyCoupon: builder.mutation<OrderPatchResponse, { coupon: string; orderId: number }>({
      query: ({ orderId, ...body }) => ({
        url: `/v2/orders/${orderId}`,
        method: 'PATCH',
        body,
      }),
    }),

    confirmOrder: builder.mutation<OrderPatchResponse, { orderId: number }>({
      query: ({ orderId }) => ({
        url: `/v2/orders/${orderId}`,
        method: 'PATCH',
        body: {
          status: 'paid',
        },
      }),
    }),

    getOrderPreference: builder.query<TutorBookingCommonFields, number>({
      query: (orderId: number) => ({
        url: `/v2/orders/${orderId}/preference`,
        method: 'GET',
      }),
      transformResponse: (preference: OrderPreference) => {
        return createBookingForSelfCartItemFromOrderPreference(preference) as TutorBookingCommonFields
      },
    }),
    updateOrderPreference: builder.mutation<void, { orderId: number; preference: Partial<OrderPreference> }>({
      invalidatesTags: [STUDENT_API_TAGS.StudentPreference],
      query: ({ orderId, preference }) => ({
        url: `/v2/orders/${orderId}/preference`,
        method: 'PATCH',
        body: preference,
      }),
    }),
  }),
})

export const {
  useAddOrderMutation,
  useApplyCouponMutation,
  useConfirmOrderMutation,
  useGetOrderPreferenceQuery,
  useUpdateOrderPreferenceMutation,
} = orderApi
